import { ParaglideMessage } from '@inlang/paraglide-js-react';
import type { SampleCoverage } from '../../lib/endpointFields';
import { m } from '../../paraglide/messages';
import { REFERENCE_ID } from './EndpointReference';

/**
 * Says over the console's authored sample that it is a cut-down illustration,
 * with the counts, so a reader never prices a 72-field response off 6 fields.
 * The note sits beside the JSON rather than inside it, so a copied sample stays
 * the valid document it is.
 */
export const SampleCoverageNote = ({ coverage }: { coverage: SampleCoverage }) => (
  <p className="border-b border-line-2 px-4 py-2.5 text-13 text-text-2">
    <ParaglideMessage
      message={m.endpoint_sample_coverage}
      inputs={{ shown: coverage.shown, total: coverage.total }}
      markup={{
        link: ({ children }) => (
          <a className="text-accent hover:underline" href={`#${REFERENCE_ID}`}>
            {children}
          </a>
        ),
      }}
    />
  </p>
);
